import { axios } from '@/lib/axios'
import { useQuery } from '@tanstack/react-query'

export const getALs = async (query) => {
  const { page, pageSize, sortBy = '', orderBy = 1, filters = {} } = query

  const transformedFilters = { ...filters }
  Object.keys(transformedFilters).forEach((key) => {
    if (Array.isArray(transformedFilters[key])) {
      transformedFilters[key] = transformedFilters[key].join(',')
    }
  })

  const params = {
    page,
    limit: pageSize,
    sortBy: sortBy || 'country', // Default to 'country' to avoid empty string error
    orderBy,
    ...transformedFilters,
  }
  const response = await axios.get('/ALs', { params })
  return response.data
}

const useAL = () => {
  const useFetchALs = (query) => {
    return useQuery({
      queryKey: ['ALs', query],
      queryFn: () => getALs(query),
      keepPreviousData: true,
    })
  }

  return {
    useFetchALs,
  }
}

export default useAL
